import BasicContentTextCards from './BasicContentTextCards';

export { type BasicContentTextCardsProps } from './BasicContentTextCards';
export default BasicContentTextCards;
